const croppingRatio = (state = null, action) => {
  switch (action.type) {
    case "UPDATE_CROPPING_RATIO":
      return action.value;
    default:
      return state;
  }
};

export default croppingRatio;
